// Navigation, Kopf- und Fußtexte des englischen Bereichs (eigene Datei, damit Kopf/Fuß nicht alle englischen Texte laden).
export const NAV_EN = [
  { to: "/en/photo-booths", label: "Photo booths" },
  { to: "/en/kreulbooth", label: "Software" },
  { to: "/en/why-us", label: "Why us" },
  { to: "/en/faq", label: "FAQ" },
  { to: "/en/contact", label: "Contact" },
];

export const HEADER_EN = {
  home: "/en",
  contactPath: "/en/contact",
  contact: "Get in touch",
  quote: "Request a quote",
  languages: "Language",
};

export const FOOTER_EN = {
  testid: "site-footer-en",
  tagline: "Professional photo booth specialist from Germany. Own workshop and showroom in Bottrop, Ruhr area. Worldwide delivery.",
  whatsappHref: "https://wa.me/4915678575025?text=Hello%2C%20I%20am%20interested%20in%20buying%20a%20photo%20booth%20and%20have%20a%20question.",
  columns: [
    { title: "Products", links: [
      { to: "/en/photo-booths", label: "All models" },
      { to: "/en/photo-booths?cat=fotoboxen", label: "Photo booths" },
      { to: "/en/photo-booths?cat=fotospiegel", label: "Photo mirrors" },
      { to: "/en/photo-booths?cat=spezial", label: "360° & special systems" },
      { to: "/en/kreulbooth", label: "KreulBooth software" },
    ] },
    { title: "Company", links: [
      { to: "/en/why-us", label: "Why us" },
      { to: "/en/faq", label: "FAQ" },
      { to: "/en/contact", label: "Contact & quote" },
      { to: "/", label: "German website (Deutsch)" },
    ] },
  ],
  contactTitle: "Contact",
  address: ["Kreul Media Group", "Im Fuhlenbrock 113", "46242 Bottrop, Germany"],
  copyright: "fotoboxverkauf.de: Kreul Media Group, Germany. Legal documents are provided in German.",
  legal: [
    { to: "/impressum", label: "Legal notice" },
    { to: "/datenschutz", label: "Privacy policy" },
    { to: "/agb", label: "Terms & conditions" },
    { to: "/widerrufsbelehrung", label: "Right of withdrawal" },
    { to: "/en/cancel", label: "Cancel contracts here" },
  ],
  cookies: "Cookie settings",
};
